
function MSAssignmentReportLoggerUser() {
    /// <summary>
    /// This object provides js functions for the Widget.Membership.Assigment.* <br/>
    /// <br/>
    /// Author: ARF<br />
    /// Date: 11.5.2016<br />
    /// Copyright ©: EUDT GmbH 2016 <br />
    /// Version-History:<br />
    /// **********************************************************************<br />
    /// *** v1.0.0 - 11.5.2016                                               *<br />
    /// **********************************************************************<br />
    /// * - basic functionality                                              *<br />
    /// **********************************************************************<br />
    /// </summary>
  
}

MSAssignmentReportLoggerUser.prototype = new window.MSAssignment();

MSAssignmentReportLoggerUser.prototype.loadFirstInList = function () {
    
};
MSAssignmentReportLoggerUser.prototype.init = function () {
    var me = this;
    try {
        window.MSAssignment.prototype.init.call(me);

        me.visual.find('.vc-list').height(((me.visual.height())/2)-22);
        me.visual.find("#divSource").css({ "margin": "0","margin-top":"2px" });
        me.visual.find("#divTarget").css({ "margin": "0", "margin-top":"20px" });

        window._VCMQ.addConsumer(me.vcgid);
        window._VCMQ.consume(me.visual, me.vcgid, function (event) { me.doEvent(event); });
    } catch (ex) {
        me.writeError('MSAssignmentReportLoggerUser.init', ex);

    }

}
MSAssignmentReportLoggerUser.prototype.loadItems = function (id) {
    var me = this;
    try {
        me.signalParameter = "";
        me.parameter = JSON.stringify({ "type": 1, id: me.rrid, assid: me.assID });
        window.MSAssignment.prototype.loadItems.call(me, id);
    } catch (ex) {
        me.writeError('MSAssignmentReportLoggerUser.loadItemsOVERLOAD', ex);
        return false;
    }
    return true;
};
MSAssignmentReportLoggerUser.prototype.doEvent = function(event) {
    var me = this;
    try {
        if (event.msg === "USER_UPDATED") {
            me.loadItems(me.assID);
        }
    } catch (ex) {
        me.writeError('MSAssignmentReportLoggerUser.doEvent', ex);
    }
};

MSAssignmentReportLoggerUser.prototype.addspecificClickHandler = function () {
    /// <summary>
    /// This function inits the assigment specific click handler if implemented
    /// </summary>
    ///<param name='row'> a row object to add the item </param>
    var me = this;
    try {
        if (me.error) { return false; }
        me.visual.find("#lstTarget").off("click").on("click", " .uedit", function () {
            var html = $(this).data("name");
            window.VisualCoreService.getVisualContentByName("FORM_REPORT_USER", "divUserForm", '27.11.2015', 250, 200, JSON.stringify({ "id": $(this).data("id") }), "", 1, function (result) {
                me.dialog = $("<div>").html(result);
                me.visual.append(me.dialog);
                me.dialog.dialog({
                    title: html,
                    width: 800,
                    height: 370,
                    modal: true,
                    resizable: false,
                    autoresize: false,
                    draggable:false,
                    dialogClass: 'saveDialog',
                    buttons: [
                    {
                        text: me.resources.close,
                            click: function() {
                                me.dialog.html("");
                                me.dialog.dialog('close');

                                return true;
                            }
                        }
                    ],
                    close: function() {
                        $(this).dialog("destroy");
                    }
                });
             
                me.dialog.find(".ui-dialog-buttonpane").css({"border":"none"});

            });
        });
    } catch (ex) {
        me.writeError('MSAssignmentReportLoggerUser.addspecificClickHandler', ex);
        return false;
    }
    return true;
};

MSAssignmentReportLoggerUser.prototype.addAssignmentItemSpecifics = function (row) {
    /// <summary>
    /// This function inits the assigment specific icons if implemented
    /// </summary>
    ///<param name='row'> a row object to add the item </param>
    var me = this;
    var sTmp = "";
    var bPDF, bXLS;
    try {
        if (me.error) { return false; }
        bPDF = (row.filetype & 1) === 1;
        bXLS = (row.filetype & 2) === 2;
        if (row.locked === false) {
            sTmp += me.resources.icon_user_locked + " ";
        }
        if (row.registered === false) {
            sTmp += me.resources.icon_user_unregistered + " ";
        }
        if (row.deleted === true) {
            sTmp += me.resources.icon_user_deleted + " ";
        }
        sTmp += "<div class='uedit button-toggle'data-id='" + row.arluid + "' data-count='" + row.count + "' data-name='" + row.prefix + " - " + row.name + "' >" + me.resources.change + "</div>";

        if (row.email) {
            sTmp += "<i class='fa fa-envelope fa-fw icon-color-info report-icon-filetype' title='" + me.resources.sendMail +"'></i>";
        }
        if (bPDF) {
            sTmp += "<i class='fa fa-file-pdf fa-fw icon-color-info report-icon-filetype' title='PDF'></i>";
        }
        if (bXLS) {
            sTmp += "<i class='fa fa-file-excel fa-fw icon-color-info report-icon-filetype' title='XLS'></i>";
        }
        return sTmp;
    } catch (ex) {
        me.writeError('MSAssignmentReportLoggerUser.addAssignmentmentItemSpecifics', ex);
        return false;
    }
};


MSAssignmentReportLoggerUser.prototype.save = function (type, id) {
    /// <summary>
    /// this function is an overlaod of the MSAssignment Save Function <br/>
    /// it reloads the complete assignment lists afer add/delete <br/>
    /// and it tests whether a user might not see the report afterwards
    /// </summary>
    var me = this;
    try {
        if (me.error) { return false; }
        if (type === 2 && me.visual.find("#lstTarget .vc-list-item[data-id='" + id + "'] .uedit").data("count") === 1) {
            $("<div id='conf'>"+ me.resources.reportNoAccess + "</div>").dialog({
                resizable: false,
                height: "auto",
                width: 400,
                dialogClass: "saveDialog",
                buttons: [
                    {
                        text: me.resources.yes,
                        click: function () {
                            me.saveWs(type,id);
                            $(this).dialog("close");
                        }
                    }, {
                        text: me.resources.no,
                        click: function () {
                            setTimeout(function () { me.visual.find("#lstSource .vc-list-item[data-id='" + id + "']").trigger("dblclick"); }, 100);
                            $(this).dialog("close");
                        }
                    }
                ]
            });
        } else {
            me.saveWs(type, id);
        }
        //window._VCMQ.produce()
        return true;
    } catch (ex) {
        me.writeError('save', ex);
        return false;
    }

};

MSAssignmentReportLoggerUser.prototype.saveWs = function (type, id){
    /// <summary>
    /// This function takes an entry id, hides the entry, sends the id to the server for deleting and updates the sorting.
    /// </summary>
    var me = this;
    try {
        if (me.error) { return false; }
        window.VisualCoreService.updateData(me.vcvid, me.vcgid, window.getCurrentTimestamp(), 0, 0, '', '', me.deviceType, me.langid, JSON.stringify({ 'type': type, 'id': id, 'assID': me.assID }),
          function (result) {
              if (result !== true) {
                  me.showMessage(me.resources.err_saveData, true);
                  return false;
              
              } else {
                  me.loadItems(me.assID);
              }
              if (me.VCMQ_update_message.length > 0) {
                  window._VCMQ.produce(me.visual, me.vcgid, me.VCMQ_update_message, '');
              }
              return true;
            });
        window._VCMQ.produce(me.visual, me.vcgid, 'USER_COUNT_CHANGED', { "assid": me.assID });

    } catch (ex) {
        me.writeError('savews', ex);
        return false;
    }
    return true;
};